import React from 'react';
import { datasetUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DatasetNotificationSubscribersAction = ({ code, disabled }) => (
  <RibbonMenu
    url={`${datasetUrl({ code }, '#')}/subscribers`}
    name="subscribers"
    icon="eye"
    message="actions.subscribers"
    className="aridhia-dataset-notification-subscribers-action"
    disabled={disabled}
  />
);

export default DatasetNotificationSubscribersAction;
